/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Add_MemberInputs */

const cs_settings_teams_add_member = /** @type {(inputs: Settings_Teams_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat člena`)
};

const en_settings_teams_add_member = /** @type {(inputs: Settings_Teams_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add member`)
};

/**
* | output |
* | --- |
* | "Add member" |
*
* @param {Settings_Teams_Add_MemberInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_add_member = /** @type {((inputs?: Settings_Teams_Add_MemberInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Add_MemberInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_add_member(inputs)
	return cs_settings_teams_add_member(inputs)
});